import { DatePicker } from '~/components';

export const FormCalendar = ({
  date,
  setDate,
  label,
}: {
  date: Date;
  setDate: (date: Date) => void;
  label?: string;
}) => {
  return (
    <div className="space-y-4">
      <div>{label || 'Date'}</div>

      <DatePicker
        date={date}
        setDate={(event) => {
          if (!(event instanceof Date)) return;

          setDate(event);
          document.getElementById('hidden')?.focus();
        }}
      />
    </div>
  );
};
